import { useGetAllFavoritesQuery } from './query/favorites/useGetAllFavoritesQuery'
import { useElementalListsStore } from '~~/src/stores/useElementalListsStore'

export const useGetAllFavorites = () => {
  const { state } = useElementalListsStore()
  const { data, isLoading, error, refetch } = useGetAllFavoritesQuery()

  const elementalsFiltered = computed(() => {
    const query = state.query?.trim().toLowerCase()
    const activeFilters = Object.values(state.viewsActives ?? {}).filter(view => view?.filterActive).map(view => view?.elementaltype)

    const favoritesFiltered = data.value?.filter((item) => {
      return activeFilters.includes(item.elementalTypeId)
    })

    if (!query)
      return favoritesFiltered

    return favoritesFiltered?.filter(({ title, id }) => {
      const idStr = id.toString().toLowerCase()
      return title.toLowerCase().includes(query) || idStr.includes(query)
    }) || []
  })

  return {
    elementalsFiltered,
    isLoading,
    error,
    refetch,
  }
}
